import React, { FC } from 'react';
import { useTectonTheme } from '@tecton/ComponentRedesign/Theme/ThemeProvider';
import styled from '@emotion/styled';

import { ReactComponent as AccountsAndAccess } from '@tecton/ComponentRedesign/lib/Icons/Icon/AccountsAndAccess.svg';
import { ReactComponent as Admin } from '@tecton/ComponentRedesign/lib/Icons/Icon/Admin.svg';
import { ReactComponent as Aggregation } from '@tecton/ComponentRedesign/lib/Icons/Icon/Aggregation.svg';
import { ReactComponent as App } from '@tecton/ComponentRedesign/lib/Icons/Icon/App.svg';
import { ReactComponent as ArrowUp } from '@tecton/ComponentRedesign/lib/Icons/Icon/ArrowUp.svg';
import { ReactComponent as ArrowDown } from '@tecton/ComponentRedesign/lib/Icons/Icon/ArrowDown.svg';
import { ReactComponent as ArrowUpRight } from '@tecton/ComponentRedesign/lib/Icons/Icon/ArrowUpRight.svg';
import { ReactComponent as Book } from '@tecton/ComponentRedesign/lib/Icons/Icon/Book.svg';
import { ReactComponent as Brain } from '@tecton/ComponentRedesign/lib/Icons/Icon/Brain.svg';
import { ReactComponent as Calendar } from '@tecton/ComponentRedesign/lib/Icons/Icon/Calendar.svg';
import { ReactComponent as Cart } from '@tecton/ComponentRedesign/lib/Icons/Icon/Cart.svg';
import { ReactComponent as Check } from '@tecton/ComponentRedesign/lib/Icons/Icon/Check.svg';
import { ReactComponent as CheckCircle } from '@tecton/ComponentRedesign/lib/Icons/Icon/CheckCircle.svg';
import { ReactComponent as Checkmark } from '@tecton/ComponentRedesign/lib/Icons/Icon/Checkmark.svg';
import { ReactComponent as ChevronDown } from '@tecton/ComponentRedesign/lib/Icons/Icon/ChevronDown.svg';
import { ReactComponent as ChevronRight } from '@tecton/ComponentRedesign/lib/Icons/Icon/ChevronRight.svg';
import { ReactComponent as ChipSparkle } from '@tecton/ComponentRedesign/lib/Icons/Icon/ChipSparkle.svg';
import { ReactComponent as CloseSmall } from '@tecton/ComponentRedesign/lib/Icons/Icon/CloseSmall.svg';
import { ReactComponent as Code } from '@tecton/ComponentRedesign/lib/Icons/Icon/Code.svg';
import { ReactComponent as CodeDocument } from '@tecton/ComponentRedesign/lib/Icons/Icon/CodeDocument.svg';
import { ReactComponent as Collapse } from '@tecton/ComponentRedesign/lib/Icons/Icon/Collapse.svg';
import { ReactComponent as Columns } from '@tecton/ComponentRedesign/lib/Icons/Icon/Columns.svg';
import { ReactComponent as Comment } from '@tecton/ComponentRedesign/lib/Icons/Icon/Comment.svg';
import { ReactComponent as Compute } from '@tecton/ComponentRedesign/lib/Icons/Icon/Compute.svg';
import { ReactComponent as ComputeV2 } from '@tecton/ComponentRedesign/lib/Icons/Icon/ComputeV2.svg';
import { ReactComponent as Copy } from '@tecton/ComponentRedesign/lib/Icons/Icon/Copy.svg';
import { ReactComponent as Danger } from '@tecton/ComponentRedesign/lib/Icons/Icon/Danger.svg';
import { ReactComponent as DataQuality } from '@tecton/ComponentRedesign/lib/Icons/Icon/DataQuality.svg';
import { ReactComponent as Dataflow } from '@tecton/ComponentRedesign/lib/Icons/Icon/Dataflow.svg';
import { ReactComponent as DataflowSummary } from '@tecton/ComponentRedesign/lib/Icons/Icon/DataflowSummary.svg';
import { ReactComponent as DataflowV2 } from '@tecton/ComponentRedesign/lib/Icons/Icon/DataflowV2.svg';
import { ReactComponent as Dataframe } from '@tecton/ComponentRedesign/lib/Icons/Icon/Dataframe.svg';
import { ReactComponent as Dataset } from '@tecton/ComponentRedesign/lib/Icons/Icon/Dataset.svg';
import { ReactComponent as DatasetV2 } from '@tecton/ComponentRedesign/lib/Icons/Icon/DatasetV2.svg';
import { ReactComponent as DevelopmentWorkspace } from '@tecton/ComponentRedesign/lib/Icons/Icon/DevelopmentWorkspace.svg';
import { ReactComponent as Documentation } from '@tecton/ComponentRedesign/lib/Icons/Icon/Documentation.svg';
import { ReactComponent as DrawerHide } from '@tecton/ComponentRedesign/lib/Icons/Icon/DrawerHide.svg';
import { ReactComponent as DrawerShow } from '@tecton/ComponentRedesign/lib/Icons/Icon/DrawerShow.svg';
import { ReactComponent as Edit } from '@tecton/ComponentRedesign/lib/Icons/Icon/Edit.svg';
import { ReactComponent as Embedding } from '@tecton/ComponentRedesign/lib/Icons/Icon/Embedding.svg';
import { ReactComponent as EmbeddingModel } from '@tecton/ComponentRedesign/lib/Icons/Icon/EmbeddingModel.svg';
import { ReactComponent as Entities } from '@tecton/ComponentRedesign/lib/Icons/Icon/Entities.svg';
import { ReactComponent as EntitiesV2 } from '@tecton/ComponentRedesign/lib/Icons/Icon/EntitiesV2.svg';
import { ReactComponent as Exit } from '@tecton/ComponentRedesign/lib/Icons/Icon/Exit.svg';
import { ReactComponent as Expand } from '@tecton/ComponentRedesign/lib/Icons/Icon/Expand.svg';
import { ReactComponent as Eye } from '@tecton/ComponentRedesign/lib/Icons/Icon/Eye.svg';
import { ReactComponent as EyeHide } from '@tecton/ComponentRedesign/lib/Icons/Icon/EyeHide.svg';
import { ReactComponent as FeatureBatch } from '@tecton/ComponentRedesign/lib/Icons/Icon/FeatureBatch.svg';
import { ReactComponent as FeatureService } from '@tecton/ComponentRedesign/lib/Icons/Icon/FeatureService.svg';
import { ReactComponent as FeatureServiceV2 } from '@tecton/ComponentRedesign/lib/Icons/Icon/FeatureServiceV2.svg';
import { ReactComponent as FeatureStream } from '@tecton/ComponentRedesign/lib/Icons/Icon/FeatureStream.svg';
import { ReactComponent as FeatureView } from '@tecton/ComponentRedesign/lib/Icons/Icon/FeatureView.svg';
import { ReactComponent as FeatureViewV2 } from '@tecton/ComponentRedesign/lib/Icons/Icon/FeatureViewV2.svg';
import { ReactComponent as Filters } from '@tecton/ComponentRedesign/lib/Icons/Icon/Filters.svg';
import { ReactComponent as FlowRag } from '@tecton/ComponentRedesign/lib/Icons/Icon/FlowRag.svg';
import { ReactComponent as Folder } from '@tecton/ComponentRedesign/lib/Icons/Icon/Folder.svg';
import { ReactComponent as Fraud } from '@tecton/ComponentRedesign/lib/Icons/Icon/Fraud.svg';
import { ReactComponent as GearCogs } from '@tecton/ComponentRedesign/lib/Icons/Icon/GearCogs.svg';
import { ReactComponent as Group } from '@tecton/ComponentRedesign/lib/Icons/Icon/Group.svg';
import { ReactComponent as Images } from '@tecton/ComponentRedesign/lib/Icons/Icon/Images.svg';
import { ReactComponent as Information } from '@tecton/ComponentRedesign/lib/Icons/Icon/Information.svg';
import { ReactComponent as Integration } from '@tecton/ComponentRedesign/lib/Icons/Icon/Integration.svg';
import { ReactComponent as IngestServerGroup } from '@tecton/ComponentRedesign/lib/Icons/Icon/IngestServerGroup.svg';
import { ReactComponent as Jobs } from '@tecton/ComponentRedesign/lib/Icons/Icon/Jobs.svg';
import { ReactComponent as KeyChain } from '@tecton/ComponentRedesign/lib/Icons/Icon/KeyChain.svg';
import { ReactComponent as Lock } from '@tecton/ComponentRedesign/lib/Icons/Icon/Lock.svg';
import { ReactComponent as Log } from '@tecton/ComponentRedesign/lib/Icons/Icon/Log.svg';
import { ReactComponent as LogOut } from '@tecton/ComponentRedesign/lib/Icons/Icon/LogOut.svg';
import { ReactComponent as Logo } from '@tecton/ComponentRedesign/lib/Icons/Icon/Logo.svg';
import { ReactComponent as MagnifyingGlass } from '@tecton/ComponentRedesign/lib/Icons/Icon/MagnifyingGlass.svg';
import { ReactComponent as Mail } from '@tecton/ComponentRedesign/lib/Icons/Icon/Mail.svg';
import { ReactComponent as Monitoring } from '@tecton/ComponentRedesign/lib/Icons/Icon/Monitoring.svg';
import { ReactComponent as NotSet } from '@tecton/ComponentRedesign/lib/Icons/Icon/NotSet.svg';
import { ReactComponent as OfflineDatabase } from '@tecton/ComponentRedesign/lib/Icons/Icon/OfflineDatabase.svg';
import { ReactComponent as OnlineDatabase } from '@tecton/ComponentRedesign/lib/Icons/Icon/OnlineDatabase.svg';
import { ReactComponent as PermissionsIcon } from '@tecton/ComponentRedesign/lib/Icons/Icon/PermissionsIcon.svg';
import { ReactComponent as Plus } from '@tecton/ComponentRedesign/lib/Icons/Icon/Plus.svg';
import { ReactComponent as Popout } from '@tecton/ComponentRedesign/lib/Icons/Icon/Popout.svg';
import { ReactComponent as Preview } from '@tecton/ComponentRedesign/lib/Icons/Icon/Preview.svg';
import { ReactComponent as ProductionWorkspace } from '@tecton/ComponentRedesign/lib/Icons/Icon/ProductionWorkspace.svg';
import { ReactComponent as Prompt } from '@tecton/ComponentRedesign/lib/Icons/Icon/Prompt.svg';
import { ReactComponent as Puzzle } from '@tecton/ComponentRedesign/lib/Icons/Icon/Puzzle.svg';
import { ReactComponent as Question } from '@tecton/ComponentRedesign/lib/Icons/Icon/Question.svg';
import { ReactComponent as QuestionInCircle } from '@tecton/ComponentRedesign/lib/Icons/Icon/QuestionInCircle.svg';
import { ReactComponent as ReceiptOrders } from '@tecton/ComponentRedesign/lib/Icons/Icon/ReceiptOrders.svg';
import { ReactComponent as Recent } from '@tecton/ComponentRedesign/lib/Icons/Icon/Recent.svg';
import { ReactComponent as Refresh } from '@tecton/ComponentRedesign/lib/Icons/Icon/Refresh.svg';
import { ReactComponent as Registry } from '@tecton/ComponentRedesign/lib/Icons/Icon/Registry.svg';
import { ReactComponent as RequestDataSource } from '@tecton/ComponentRedesign/lib/Icons/Icon/RequestDataSource.svg';
import { ReactComponent as Retrieval } from '@tecton/ComponentRedesign/lib/Icons/Icon/Retrieval.svg';
import { ReactComponent as Retry } from '@tecton/ComponentRedesign/lib/Icons/Icon/Retry.svg';
import { ReactComponent as Robot } from '@tecton/ComponentRedesign/lib/Icons/Icon/Robot.svg';
import { ReactComponent as Rocket } from '@tecton/ComponentRedesign/lib/Icons/Icon/Rocket.svg';
import { ReactComponent as Running } from '@tecton/ComponentRedesign/lib/Icons/Icon/Running.svg';
import { ReactComponent as Scalable } from '@tecton/ComponentRedesign/lib/Icons/Icon/Scalable.svg';
import { ReactComponent as Search } from '@tecton/ComponentRedesign/lib/Icons/Icon/Search.svg';
import { ReactComponent as Settings } from '@tecton/ComponentRedesign/lib/Icons/Icon/Settings.svg';
import { ReactComponent as Sources } from '@tecton/ComponentRedesign/lib/Icons/Icon/Sources.svg';
import { ReactComponent as SourcesV2 } from '@tecton/ComponentRedesign/lib/Icons/Icon/SourcesV2.svg';
import { ReactComponent as Sparkles } from '@tecton/ComponentRedesign/lib/Icons/Icon/Sparkles.svg';
import { ReactComponent as SparklesCircle } from '@tecton/ComponentRedesign/lib/Icons/Icon/SparklesCircle.svg';
import { ReactComponent as Star } from '@tecton/ComponentRedesign/lib/Icons/Icon/Star.svg';
import { ReactComponent as StructuredData } from '@tecton/ComponentRedesign/lib/Icons/Icon/StructuredData.svg';
import { ReactComponent as Support } from '@tecton/ComponentRedesign/lib/Icons/Icon/Support.svg';
import { ReactComponent as SupportLifeRing } from '@tecton/ComponentRedesign/lib/Icons/Icon/SupportLifeRing.svg';
import { ReactComponent as SupportV2 } from '@tecton/ComponentRedesign/lib/Icons/Icon/SupportV2.svg';
import { ReactComponent as Tag } from '@tecton/ComponentRedesign/lib/Icons/Icon/Tag.svg';
import { ReactComponent as Template } from '@tecton/ComponentRedesign/lib/Icons/Icon/Template.svg';
import { ReactComponent as Text } from '@tecton/ComponentRedesign/lib/Icons/Icon/Text.svg';
import { ReactComponent as Timestamp } from '@tecton/ComponentRedesign/lib/Icons/Icon/Timestamp.svg';
import { ReactComponent as Timezone } from '@tecton/ComponentRedesign/lib/Icons/Icon/Timezone.svg';
import { ReactComponent as Transfer } from '@tecton/ComponentRedesign/lib/Icons/Icon/Transfer.svg';
import { ReactComponent as Transformations } from '@tecton/ComponentRedesign/lib/Icons/Icon/Transformations.svg';
import { ReactComponent as TransformServerGroup } from '@tecton/ComponentRedesign/lib/Icons/Icon/TransformServerGroup.svg';
import { ReactComponent as Trash } from '@tecton/ComponentRedesign/lib/Icons/Icon/Trash.svg';
import { ReactComponent as UnstructuredData } from '@tecton/ComponentRedesign/lib/Icons/Icon/UnstructuredData.svg';
import { ReactComponent as UserCircle } from '@tecton/ComponentRedesign/lib/Icons/Icon/UserCircle.svg';
import { ReactComponent as UserGroup } from '@tecton/ComponentRedesign/lib/Icons/Icon/UserGroup.svg';
import { ReactComponent as UserInfo } from '@tecton/ComponentRedesign/lib/Icons/Icon/UserInfo.svg';
import { ReactComponent as Viewer } from '@tecton/ComponentRedesign/lib/Icons/Icon/Viewer.svg';
import { ReactComponent as Warning } from '@tecton/ComponentRedesign/lib/Icons/Icon/Warning.svg';
import { ReactComponent as WhatsNew } from '@tecton/ComponentRedesign/lib/Icons/Icon/WhatsNew.svg';
import { ReactComponent as Wordmark } from '@tecton/ComponentRedesign/lib/Icons/Icon/Wordmark.svg';
import { ReactComponent as Workspaces } from '@tecton/ComponentRedesign/lib/Icons/Icon/Workspaces.svg';
import { ReactComponent as Fail } from '@tecton/ComponentRedesign/lib/Icons/Icon/Fail.svg';
import { ReactComponent as ChevronUp } from '@tecton/ComponentRedesign/lib/Icons/Icon/ChevronUp.svg';
import { ReactComponent as ChevronLeft } from '@tecton/ComponentRedesign/lib/Icons/Icon/ChevronLeft.svg';
import { ReactComponent as LargeChevronRight } from '@tecton/ComponentRedesign/lib/Icons/Icon/LargeChevronRight.svg';
import { ReactComponent as LargeChevronUp } from '@tecton/ComponentRedesign/lib/Icons/Icon/LargeChevronUp.svg';
import { ReactComponent as LargeChevronDown } from '@tecton/ComponentRedesign/lib/Icons/Icon/LargeChevronDown.svg';
import { ReactComponent as LargeChevronLeft } from '@tecton/ComponentRedesign/lib/Icons/Icon/LargeChevronLeft.svg';
import { ReactComponent as Error } from '@tecton/ComponentRedesign/lib/Icons/Icon/Error.svg';

export type IconType =
  | 'AccountsAndAccess'
  | 'Admin'
  | 'Aggregation'
  | 'App'
  | 'ArrowUp'
  | 'ArrowDown'
  | 'ArrowUpRight'
  | 'ArrowDown'
  | 'Book'
  | 'Brain'
  | 'Calendar'
  | 'Cart'
  | 'Check'
  | 'CheckCircle'
  | 'Checkmark'
  | 'ChevronDown'
  | 'ChevronRight'
  | 'ChipSparkle'
  | 'CloseSmall'
  | 'Code'
  | 'CodeDocument'
  | 'Collapse'
  | 'Columns'
  | 'Comment'
  | 'Compute'
  | 'ComputeV2'
  | 'Copy'
  | 'Danger'
  | 'DataQuality'
  | 'Dataflow'
  | 'DataflowSummary'
  | 'DataflowV2'
  | 'Dataframe'
  | 'Dataset'
  | 'DatasetV2'
  | 'DevelopmentWorkspace'
  | 'Documentation'
  | 'DrawerHide'
  | 'DrawerShow'
  | 'Edit'
  | 'Embedding'
  | 'EmbeddingModel'
  | 'Entities'
  | 'EntitiesV2'
  | 'Exit'
  | 'Expand'
  | 'Eye'
  | 'EyeHide'
  | 'FeatureBatch'
  | 'FeatureService'
  | 'FeatureServiceV2'
  | 'FeatureStream'
  | 'FeatureView'
  | 'FeatureViewV2'
  | 'Filters'
  | 'FlowRag'
  | 'Folder'
  | 'Fraud'
  | 'GearCogs'
  | 'Group'
  | 'Images'
  | 'Information'
  | 'Integration'
  | 'IngestServerGroup'
  | 'Jobs'
  | 'KeyChain'
  | 'Lock'
  | 'Log'
  | 'LogOut'
  | 'Logo'
  | 'MagnifyingGlass'
  | 'Mail'
  | 'Monitoring'
  | 'NotSet'
  | 'OfflineDatabase'
  | 'OnlineDatabase'
  | 'PermissionsIcon'
  | 'Plus'
  | 'Popout'
  | 'Preview'
  | 'ProductionWorkspace'
  | 'Prompt'
  | 'Puzzle'
  | 'Question'
  | 'QuestionInCircle'
  | 'ReceiptOrders'
  | 'Recent'
  | 'Refresh'
  | 'Registry'
  | 'RequestDataSource'
  | 'Retrieval'
  | 'Retry'
  | 'Robot'
  | 'Rocket'
  | 'Running'
  | 'Scalable'
  | 'Search'
  | 'Settings'
  | 'Sources'
  | 'SourcesV2'
  | 'Sparkles'
  | 'SparklesCircle'
  | 'Star'
  | 'StructuredData'
  | 'Support'
  | 'SupportLifeRing'
  | 'SupportV2'
  | 'Tag'
  | 'Template'
  | 'Text'
  | 'Timestamp'
  | 'Timezone'
  | 'Transfer'
  | 'Transformations'
  | 'TransformServerGroup'
  | 'Trash'
  | 'UnstructuredData'
  | 'UserCircle'
  | 'UserGroup'
  | 'UserInfo'
  | 'Viewer'
  | 'Warning'
  | 'WhatsNew'
  | 'Wordmark'
  | 'Workspaces'
  | 'Fail'
  | 'ChevronUp'
  | 'ChevronLeft'
  | 'LargeChevronLeft'
  | 'LargeChevronRight'
  | 'LargeChevronUp'
  | 'LargeChevronDown'
  | 'Error';

export type IconSize = 'xs' | 's' | 'm' | 'l';

export interface IconProps {
  icon: IconType;
  type: 'mono' | 'color' | 'custom';
  size: IconSize;
  color?: string;
}

const Icons: Record<IconType, React.ReactNode> = {
  AccountsAndAccess: <AccountsAndAccess />,
  Admin: <Admin />,
  Aggregation: <Aggregation />,
  App: <App />,
  ArrowDown: <ArrowDown />,
  ArrowUp: <ArrowUp />,
  ArrowUpRight: <ArrowUpRight />,
  Book: <Book />,
  Brain: <Brain />,
  Calendar: <Calendar />,
  Cart: <Cart />,
  Check: <Check />,
  CheckCircle: <CheckCircle />,
  Checkmark: <Checkmark />,
  ChevronDown: <ChevronDown />,
  ChevronUp: <ChevronUp />,
  ChevronLeft: <ChevronLeft />,
  ChevronRight: <ChevronRight />,
  ChipSparkle: <ChipSparkle />,
  CloseSmall: <CloseSmall />,
  Code: <Code />,
  CodeDocument: <CodeDocument />,
  Collapse: <Collapse />,
  Columns: <Columns />,
  Comment: <Comment />,
  Compute: <Compute />,
  ComputeV2: <ComputeV2 />,
  Copy: <Copy />,
  Danger: <Danger />,
  DataQuality: <DataQuality />,
  Dataflow: <Dataflow />,
  DataflowSummary: <DataflowSummary />,
  DataflowV2: <DataflowV2 />,
  Dataframe: <Dataframe />,
  Dataset: <Dataset />,
  DatasetV2: <DatasetV2 />,
  DevelopmentWorkspace: <DevelopmentWorkspace />,
  Documentation: <Documentation />,
  DrawerHide: <DrawerHide />,
  DrawerShow: <DrawerShow />,
  Edit: <Edit />,
  Embedding: <Embedding />,
  EmbeddingModel: <EmbeddingModel />,
  Entities: <Entities />,
  EntitiesV2: <EntitiesV2 />,
  Error: <Error />,
  Exit: <Exit />,
  Expand: <Expand />,
  Eye: <Eye />,
  EyeHide: <EyeHide />,
  Fail: <Fail />,
  FeatureBatch: <FeatureBatch />,
  FeatureService: <FeatureService />,
  FeatureServiceV2: <FeatureServiceV2 />,
  FeatureStream: <FeatureStream />,
  FeatureView: <FeatureView />,
  FeatureViewV2: <FeatureViewV2 />,
  Filters: <Filters />,
  FlowRag: <FlowRag />,
  Folder: <Folder />,
  Fraud: <Fraud />,
  GearCogs: <GearCogs />,
  Group: <Group />,
  Images: <Images />,
  Information: <Information />,
  Integration: <Integration />,
  IngestServerGroup: <IngestServerGroup />,
  Jobs: <Jobs />,
  KeyChain: <KeyChain />,
  Lock: <Lock />,
  Log: <Log />,
  LogOut: <LogOut />,
  Logo: <Logo />,
  MagnifyingGlass: <MagnifyingGlass />,
  Mail: <Mail />,
  Monitoring: <Monitoring />,
  NotSet: <NotSet />,
  OfflineDatabase: <OfflineDatabase />,
  OnlineDatabase: <OnlineDatabase />,
  PermissionsIcon: <PermissionsIcon />,
  Plus: <Plus />,
  Popout: <Popout />,
  Preview: <Preview />,
  ProductionWorkspace: <ProductionWorkspace />,
  Prompt: <Prompt />,
  Puzzle: <Puzzle />,
  Question: <Question />,
  QuestionInCircle: <QuestionInCircle />,
  ReceiptOrders: <ReceiptOrders />,
  Recent: <Recent />,
  Refresh: <Refresh />,
  Registry: <Registry />,
  RequestDataSource: <RequestDataSource />,
  Retrieval: <Retrieval />,
  Retry: <Retry />,
  Robot: <Robot />,
  Rocket: <Rocket />,
  Running: <Running />,
  Scalable: <Scalable />,
  Search: <Search />,
  Settings: <Settings />,
  Sources: <Sources />,
  SourcesV2: <SourcesV2 />,
  Sparkles: <Sparkles />,
  SparklesCircle: <SparklesCircle />,
  Star: <Star />,
  StructuredData: <StructuredData />,
  Support: <Support />,
  SupportLifeRing: <SupportLifeRing />,
  SupportV2: <SupportV2 />,
  Tag: <Tag />,
  Template: <Template />,
  Text: <Text />,
  Timestamp: <Timestamp />,
  Timezone: <Timezone />,
  Transfer: <Transfer />,
  Transformations: <Transformations />,
  TransformServerGroup: <TransformServerGroup />,
  Trash: <Trash />,
  UnstructuredData: <UnstructuredData />,
  UserCircle: <UserCircle />,
  UserGroup: <UserGroup />,
  UserInfo: <UserInfo />,
  Viewer: <Viewer />,
  Warning: <Warning />,
  WhatsNew: <WhatsNew />,
  Wordmark: <Wordmark />,
  Workspaces: <Workspaces />,
  LargeChevronDown: <LargeChevronDown />,
  LargeChevronLeft: <LargeChevronLeft />,
  LargeChevronRight: <LargeChevronRight />,
  LargeChevronUp: <LargeChevronUp />,
};

export const IconSizeMap: Record<IconSize, string> = {
  xs: '12px',
  s: '16px',
  m: '24px',
  l: '48px',
};

const IconWrapper = styled.div<{ color: string; size: IconSize }>`
  display: inline-block;
  line-height: 0;
  overflow: hidden;

  width: ${({ size }) => {
    return IconSizeMap[size];
  }};
  height: ${({ size }) => {
    return IconSizeMap[size];
  }};

  svg {
    width: 100%;
    height: 100%;
    display: inline;
  }

  path,
  circle,
  ellipse,
  rect {
    stroke: ${({ color }) => {
      return color;
    }};
  }
`;

const Icon: FC<IconProps> = ({ icon, type = 'mono', size = 'm', color }) => {
  const { theme } = useTectonTheme();

  const customIconColors = new Map<IconType, string>([
    ['Dataset', theme.FCOColors.dataset],
    ['DatasetV2', theme.FCOColors.dataset],
    ['Entities', theme.FCOColors.entity],
    ['EntitiesV2', theme.FCOColors.entity],
    ['FeatureView', theme.FCOColors.featureView],
    ['FeatureViewV2', theme.FCOColors.featureView],
    ['FeatureService', theme.FCOColors.featureService],
    ['FeatureServiceV2', theme.FCOColors.featureService],
    ['Transformations', theme.FCOColors.transformation],
    ['Sources', theme.FCOColors.source],
    ['SourcesV2', theme.FCOColors.source],
    ['DevelopmentWorkspace', theme.colors.success],
    ['Prompt', theme.colors.accent],
    ['Puzzle', theme.colors.accent],
    ['Aggregation', theme.colors.text],
    ['FeatureBatch', theme.FCOColors.featureView],
    ['FeatureStream', theme.FCOColors.featureView],
    ['Embedding', theme.colors.accent],
    ['Transfer', theme.colors.text],
    ['Registry', theme.colors.text],
    ['Tag', theme.colors.text],
    ['Retrieval', theme.colors.text],
    ['Integration', theme.colors.text],
    ['Timestamp', theme.colors.text],
    ['Scalable', theme.colors.text],
    ['SupportV2', theme.colors.text],
    ['Retrieval', theme.colors.text],
    ['ComputeV2', theme.colors.text],
    ['ChipSparkle', theme.colors.text],
    ['Code', theme.colors.text],
    ['Sparkles', theme.colors.accent],
    ['SparklesCircle', theme.colors.accent],
    ['Brain', theme.colors.accent],
    ['FlowRag', theme.colors.accent],
    ['StructuredData', theme.colors.text],
    ['UnstructuredData', theme.colors.text],
    ['ReceiptOrders', theme.colors.text],
    ['Text', theme.colors.text],
    ['Settings', theme.colors.text],
    ['Dataframe', theme.colors.text],
    ['Log', theme.colors.text],
    ['App', theme.colors.text],
    ['Collapse', theme.colors.text],
    ['Expand', theme.colors.text],
    ['Question', theme.colors.text],
    ['DataflowSummary', theme.colors.text],
    ['EmbeddingModel', theme.colors.text],
    ['Mail', theme.colors.text],
    ['Information', theme.colors.text],
    ['QuestionInCircle', theme.colors.text],
    ['Calendar', theme.colors.text],
    ['Documentation', theme.colors.text],
    ['CheckCircle', theme.colors.text],
    ['Check', theme.colors.text],
    ['CodeDocument', theme.colors.text],
    ['ChevronDown', theme.colors.text],
    ['ChevronRight', theme.colors.text],
    ['Plus', theme.colors.text],
    ['Admin', theme.colors.text],
    ['UserGroup', theme.colors.text],
    ['SupportLifeRing', theme.colors.text],
    ['Retry', theme.colors.text],
    ['Refresh', theme.colors.text],
    ['Warning', theme.colors.dangerText],
    ['NotSet', theme.colors.text],
    ['Recent', theme.colors.text],
    ['Running', theme.colors.text],
    ['GearCogs', theme.colors.text],
    ['Filters', theme.colors.text],
    ['Timezone', theme.colors.text],
    ['Viewer', theme.colors.text],
    ['Edit', theme.colors.text],
    ['Lock', theme.colors.text],
    ['Trash', theme.colors.text],
    ['Rocket', theme.colors.text],
    ['Comment', theme.colors.text],
    ['Popout', theme.colors.text],
    ['Search', theme.colors.text],
    ['RequestDataSource', theme.colors.text],
  ]);

  let stroke =
    type === 'mono' ? theme['v1'].colors.icon.primary : customIconColors.get(icon) ?? theme['v1'].colors.icon.danger;

  if (color) {
    stroke = color;
  }

  return (
    <IconWrapper color={stroke} size={size} theme={theme} data-testid="icon">
      {Icons[icon]}
    </IconWrapper>
  );
};

export default Icon;
